/* eslint-disable react/function-component-definition */
/* Global imports. */
import React from "react";

/* Component imports. */
import ReadTime from "@components/ReadTime";
import Contributor from "@src/components/ArticleContributor";
import ShareOnTwitter from "@components/ShareOnTwitter";
import ShareOnFacebook from "@components/ShareOnFacebook";
import ShareButton from "@src/components/ShareButton/ShareButton";

/* Model imports. */
import { KontentContributor } from "@models/kontent";

interface Props {
    title: string;
    date: string;
    content: string;
    contributorName?: string;
    contributorUrl?: string;
    slug: string;
    className: string;
}

const Sidebar = ({ title, date, content, contributorName, contributorUrl, slug, className }: Props) => (
    <aside id="article-sidebar" className={className}>
        {/* Contributor (author) */}
        {contributorName && (
            <div data-contributor={contributorName} className="w-full md:mb-4 md:text-right md:w-auto md:self-end">
                <Contributor name={contributorName} website={contributorUrl} />
            </div>
        )}

        {/* Date */}
        <div className="relative self-center sm:text-right sm:mb-4 md:self-end">
            <time className="text-gray-500 font-sans text-sm pr-2 md:pr-0 sm:text-base before:block before:bg-[#767676] before:h-4/5 before:absolute before:right-0 before:top-1/2 before:w-[1px] before:-translate-y-1/2 md:before:hidden">
                {date}
            </time>
        </div>

        {/* Read-time */}
        <div className="self-center pl-2 sm:text-right md:self-end md:ml-0 sm:mb-4 ">
            <ReadTime numChars={content.length} />
        </div>

        {/* Social media sharing */}
        <div className="self-center ml-auto md:block sm:text-right md:self-end md:ml-0 md:mb-4">
            <ul className="flex flex-col items-end justify-end flex-auto !pl-0 !list-none">
                <li className="hidden w-12 h-12 mr-2 sm:mr-0 sm:mb-2">
                    <ShareOnFacebook slug={slug} />
                </li>
                <li className="hidden w-12 h-12 mr-2 sm:mr-0 sm:mb-2">
                    <ShareOnTwitter title={title} slug={slug} />
                </li>
                <li className="w-9 h-9 sm:mb-2 sm:mr-0">
                    <ShareButton title={title} text={title} url={slug} />
                </li>
            </ul>
        </div>
    </aside>
);

export default Sidebar;
